import { Component, Injector, Input, OnInit } from '@angular/core';
import { ActiveWidget } from '../../classes/active-widget';
import { AlertService } from '../../../alerts';
import { ModalService } from '../../../modals';
import { WidgetModel } from '../../models/widget.model';
import { ActiveDashboard } from '../../classes/active-dashboard';

@Component({
    selector: 'chassis-core-dashboard-container, [dashboard-container]',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit {

    @Input() containers: Array<Array<WidgetModel>>;

    @Input() index: number;

    public widgets: Array<WidgetModel> = [];

    public hovered: boolean = false;

    constructor(protected dashboard: ActiveDashboard, protected modalService: ModalService, protected alertService: AlertService) {
    }

    ngOnInit() {
        if (Number.isNaN(this.index)) {
            throw new Error('No container number provided for dashboard ' +
                'widget container');
        }

        // Check if the container is empty or does not exist,
        // if it doesn't exist we'll fill it with an empty
        // placeholder array
        if (!this.containers[this.index]) {
            this.containers.push([]);
        }

        this.widgets = this.containers[this.index];
    }

    /**
     * Create an injector with the active dashboard reference for
     * the containers and widgets.
     *
     * @return {Injector}
     */
    public createInjector(item) {
        const widget = new ActiveWidget();

        // Add widget edit callback
        widget.setEdit(() => {
            const order = this.widgets.findIndex((i) => {
                return i === item;
            });

            // Let the dashboard edit the widget
            this.dashboard.editWidget({
                container: this.index,
                order: order,
                widget: item,
            });
        });

        // Add widget remove callback
        widget.setRemove(() => {
            const order = this.widgets.findIndex((i) => {
                return i === item;
            });

            // Let the dashboard remove the widget
            this.dashboard.removeWidget({
                container: this.index,
                order: order,
                widget: item,
            });
        });

        return Injector.create({
            providers: [{
                provide: ActiveWidget,
                useValue: widget
            }],
        });
    }

    public save() {
        this.dashboard.save();
    }

    public over() {
        this.hovered = true;
    }

    public out() {
        this.hovered = false;
    }

    public get showPlaceholder() {
        return this.widgets.length < 1 && !this.hovered;
    }

}




// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/components/container/container.component.ts